import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { ExerciseData, ExerciseViewProps } from '../exercises';

export const exerciseData222Completed: ExerciseData = {
    ExerciseView: Module2S2Exercise2Completed,
    dataKeys: [],
    questions: [],
};

export function Module2S2Exercise2Completed({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="" class="clouds">
            <Spacer />
            <LabelDisplay2 class="mb-10 text-center">Godt gået!</LabelDisplay2>
            <LabelBody class="text-center">
                Det kan for mange være svært at få prioriteret selvomsorg, og
                det er det måske også for dig. Men det har du fortjent, lige så
                meget som alle andre.
            </LabelBody>
            <LabelBody class="mt-10 text-center">
                Øv dig i at prioritere din selvomsorg ved at sætte dig et mål.
            </LabelBody>
            <Spacer />
            <SecondaryButton
                class="my-20"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: '2.2.2.goal',
                    })
                }
            >
                Jeg vil sætte mig et mål
            </SecondaryButton>
            <GhostButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Vender tilbage senere
            </GhostButton>
        </Exercise>
    );
}
